import { createStore, type StoreConfig } from '../state-helper'

type FavouritingAndWishlistingStore = {
  savedItemIds: Set<number>
  summaryFetched: boolean
  heartIconsInProgress: Set<number>

  setSavedItemIds: (savedItemIds: Set<number>) => void
  addToSavedItemIds: (savedItemId: number) => void
  removeFromSavedItemIds: (savedItemId: number) => void
  setSummaryFetched: (summaryFetched: boolean) => void
  addHeartIconInProgress: (id: number) => void
  removeHeartIconFromProgress: (id: number) => void

  reset: () => void
}

const initialSet = new Set<number>()

const favouritingAndWishlistingStore: StoreConfig<
  FavouritingAndWishlistingStore
> = (set, get) => ({
  savedItemIds: initialSet,
  summaryFetched: false,
  heartIconsInProgress: initialSet,
  setSavedItemIds: (savedItemIds: Set<number>) => {
    set({ savedItemIds })
  },
  addToSavedItemIds: (savedItemId: number) => {
    set({ savedItemIds: get().savedItemIds.add(savedItemId) })
  },
  removeFromSavedItemIds: (savedItemId: number) => {
    get().savedItemIds?.delete(savedItemId)
    set({
      savedItemIds: get().savedItemIds,
    })
  },
  setSummaryFetched: (summaryFetched: boolean) => {
    set({ summaryFetched })
  },
  addHeartIconInProgress: (id) => {
    set({ heartIconsInProgress: get().heartIconsInProgress.add(id) })
  },
  removeHeartIconFromProgress: (id: number) => {
    get().heartIconsInProgress.delete(id)
    set({
      heartIconsInProgress: get().heartIconsInProgress,
    })
  },
  reset: () => {
    set({
      savedItemIds: initialSet,
      heartIconsInProgress: initialSet,
      summaryFetched: false,
    })
  },
})

export const useFavouritingAndWishlistingStore = createStore(
  favouritingAndWishlistingStore,
  {
    name: 'favouriting_and_wishlisting_storage',
  },
)
